module.exports = __webpack_public_path__ + "static/media/logo_dispatch.d6894793.png";